import { Link } from 'react-router-dom';
import { comicList } from '@/mocks/comics';
import ComicCard from './ComicCard';

export default function LatestUpdate() {
  const latestComics = [...comicList]
    .sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime())
    .slice(0, 12);

  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">最新更新</h2>
            <p className="text-xs text-foreground-500 mt-1">每日更新，追更不等待</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            更多作品
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}